
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as testv73hAG3w2pLbtaIYhP0TME3ZDzU1SLMW3olXBA0g704Meta } from "C:/git/niem/niem-toolbox/pages/test.vue?macro=true";
import { default as indexlj2k2H2eX9_45NqNv0rcITr5_EQ7u6J5LtCWz5_45iXU_45qYMeta } from "C:/git/niem/niem-toolbox/pages/index.vue?macro=true";
import { default as searchycuUhu8ffo_45YFdNwh1E_Ph5f4phmA5E_I_rUp2ewiO4Meta } from "C:/git/niem/niem-toolbox/pages/search.vue?macro=true";
import { default as migratetg99cBZgK3rzQXLmr_45uvAPcpjaJJA_45kjF3a2L2hZPbMMeta } from "C:/git/niem/niem-toolbox/pages/migrate.vue?macro=true";
import { default as validateZCHWzsD_45a9GqpKyauaoxXqvjFaOZK91xnHL4RseQ6qMMeta } from "C:/git/niem/niem-toolbox/pages/validate.vue?macro=true";
import { default as transformw3lhLhr8P2Tm0mhWccIdoo08doc9Fd5qohxPMOJpqvwMeta } from "C:/git/niem/niem-toolbox/pages/transform.vue?macro=true";
import { default as indexAzPBtCg8sMcIbpTSKzuu_45NnD0kOXHpW70zvrTCrprEgMeta } from "C:/git/niem/niem-toolbox/pages/browse/index.vue?macro=true";
import { default as release_45notesRV1cCbDrVn71EP_45icrObvwlAB2sOuLOJdqfPHwwjkmoMeta } from "C:/git/niem/niem-toolbox/pages/release-notes.vue?macro=true";
import { default as indexWe7d4QWWZEQyCfXorVRILNCNhxUgFawgOmd9nBYtX3UMeta } from "C:/git/niem/niem-toolbox/pages/browse/[stewardKey]/index.vue?macro=true";
import { default as indexWqUGdcfSrpawfmufEZw4pX_m_evS_45bwEmEmdOylhH3UMeta } from "C:/git/niem/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/index.vue?macro=true";
import { default as indexVGVLraQOoiH_9BVVefFxoMVeCmpIoACeZV_VqpneHC4Meta } from "C:/git/niem/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/[versionNumber]/index.vue?macro=true";
import { default as _91slug_93fGZu_14LzjQvGDWh_45Md6lGkMZYSKXg1NauCy_RG0OMUMeta } from "C:/git/niem/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/[versionNumber]/[slug].vue?macro=true";
import { default as _91propertyQName_93qFYMWpCpWTypJ7j1pbzEpuMnM7OruS0jzMQSn0UGpgIMeta } from "C:/git/niem/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/[versionNumber]/[base]Type/[propertyQName].vue?macro=true";
export default [
  {
    name: "test",
    path: "/test",
    meta: testv73hAG3w2pLbtaIYhP0TME3ZDzU1SLMW3olXBA0g704Meta || {},
    component: () => import("C:/git/niem/niem-toolbox/pages/test.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("C:/git/niem/niem-toolbox/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("C:/git/niem/niem-toolbox/pages/search.vue")
  },
  {
    name: "migrate",
    path: "/migrate",
    component: () => import("C:/git/niem/niem-toolbox/pages/migrate.vue")
  },
  {
    name: "validate",
    path: "/validate",
    component: () => import("C:/git/niem/niem-toolbox/pages/validate.vue")
  },
  {
    name: "transform",
    path: "/transform",
    component: () => import("C:/git/niem/niem-toolbox/pages/transform.vue")
  },
  {
    name: "browse",
    path: "/browse",
    component: () => import("C:/git/niem/niem-toolbox/pages/browse/index.vue")
  },
  {
    name: "release-notes",
    path: "/release-notes",
    component: () => import("C:/git/niem/niem-toolbox/pages/release-notes.vue")
  },
  {
    name: "browse-stewardKey",
    path: "/browse/:stewardKey()",
    component: () => import("C:/git/niem/niem-toolbox/pages/browse/[stewardKey]/index.vue")
  },
  {
    name: "browse-stewardKey-modelKey",
    path: "/browse/:stewardKey()/:modelKey()",
    component: () => import("C:/git/niem/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/index.vue")
  },
  {
    name: "browse-stewardKey-modelKey-versionNumber",
    path: "/browse/:stewardKey()/:modelKey()/:versionNumber()",
    component: () => import("C:/git/niem/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/[versionNumber]/index.vue")
  },
  {
    name: "browse-stewardKey-modelKey-versionNumber-slug",
    path: "/browse/:stewardKey()/:modelKey()/:versionNumber()/:slug()",
    component: () => import("C:/git/niem/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/[versionNumber]/[slug].vue")
  },
  {
    name: "browse-stewardKey-modelKey-versionNumber-baseType-propertyQName",
    path: "/browse/:stewardKey()/:modelKey()/:versionNumber()/:base()Type/:propertyQName()",
    component: () => import("C:/git/niem/niem-toolbox/pages/browse/[stewardKey]/[modelKey]/[versionNumber]/[base]Type/[propertyQName].vue")
  }
]